import BaseElement from './BaseElement';
import MediaSidebarList from '../Components/Mediathek/MediaSidebarList';
class MediaSidebarListElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = MediaSidebarList;
    }
}
export default MediaSidebarListElement;
